import Vue from "vue/dist/vue.esm.js"
import ArticleCategorySearch from '../components/articleCategorySearch.vue'
import ArticleArchiveSearch from '../components/articleArchiveSearch.vue'
import ArticleContentTitleSearch from '../components/articleContentTitleSearch.vue'

new Vue({
  el: '#article-search',
  components: { ArticleArchiveSearch, ArticleCategorySearch, ArticleContentTitleSearch },
})

// article content
const stringToHTML = (str) => {
  const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body;
};
const contents = document.getElementsByClassName("trix-content");
for( let i = 0 ; i < contents.length ; i++) {
  const atags = contents[i].getElementsByTagName("a");
  for( let j = 0 ; j < atags.length ; j++) {
    const url = atags[j].href;
    const reg = new RegExp(window.location.protocol + '//' + window.location.host);
    if(!url.match(reg)){
      atags[j].target="_blank";
      atags[j].rel="noopener noreferrer";
    }
  }
}
const figures = document.getElementsByTagName("figure");
for(let i = 0; i < figures.length; i++){
  const figcaption = figures[i].getElementsByTagName("figcaption");
  if(figcaption[0]) figures[i].getElementsByTagName("img")[0].alt = figcaption[0].innerText.trim();
}
const anchors = Array.from(document.getElementsByClassName("pc")[0].getElementsByTagName("anchor"));
for(let i = 0; i < anchors.length; i++){
  const newAnchor = document.createElement('div');
  newAnchor.id = anchors[i].innerText;
  anchors[i].replaceWith(newAnchor);
}
const anchorAtags = document.getElementsByClassName("pc")[0].getElementsByTagName("a");
for(let i = 0; i < anchorAtags.length; i++){
  if(anchorAtags[i].href.match(/#/)){
    anchorAtags[i].onclick = () => {
      setTimeout(() => {window.scrollBy(0, -100);}, 1);
    }
  }
}

const customs = Array.from(document.getElementsByClassName("pc")[0].getElementsByTagName("custom"));
for(let i = 0; i < customs.length; i++){
  const custom = customs[i]
  const newCustom = document.createElement('div');
  const customHtml = stringToHTML(custom.innerText.replace(/\r\n|\r|\n|\t/g, '').replace(/>\s+</,'><'))

  customHtml.childNodes.forEach(node => {
    newCustom.appendChild(node)
  });

  customs[i].replaceWith(newCustom);
}

const anchorsSp = Array.from(document.getElementsByClassName("sp")[0].getElementsByTagName("anchor"));
for(let i = 0; i < anchorsSp.length; i++){
  const newAnchor = document.createElement('div');
  newAnchor.id = anchorsSp[i].innerText + "-sp";
  anchorsSp[i].replaceWith(newAnchor);
}
const anchorAtagsSp = document.getElementsByClassName("sp")[0].getElementsByTagName("a")
for(let i = 0; i < anchorAtagsSp.length; i++){
  if(anchorAtagsSp[i].href.match(/#/)){
    anchorAtagsSp[i].href = anchorAtagsSp[i].href + "-sp";
    anchorAtagsSp[i].onclick = () => {
      setTimeout(() => {window.scrollBy(0, -80);}, 1);
    }
  }
}
const customsSp = Array.from(document.getElementsByClassName("sp")[0].getElementsByTagName("custom"));
for(let i = 0; i < customsSp.length; i++){
  const newCustom = document.createElement('div');
  const custom= customsSp[i]
  const customHtml = stringToHTML(custom.innerText.replace(/\r\n|\r|\n|\t/g, '').replace(/>\s+</,'><'))
  customHtml.childNodes.forEach(node => {
    newCustom.appendChild(node)
  });
  customsSp[i].replaceWith(newCustom);
}

const hs = document.getElementsByClassName("pc")[0].querySelectorAll('h2, h3');
const index = document.createElement('ol');
for(let i = 0; i < hs.length; i++){
  const tag = hs[i].tagName;
  if(tag == "H2"){
    const h2li = document.createElement('li');
    const atag = document.createElement('a');
    atag.href = `#${i}`
    hs[i].id = i;
    atag.innerText = hs[i].innerText;
    
    h2li.appendChild(atag);
    index.appendChild(h2li);
  } else {
    const h3li = document.createElement('li');
    const atag = document.createElement('a');
    atag.href = `#${i}`;
    hs[i].id = i;
    atag.innerText = hs[i].innerText;

    if(hs[i-1].tagName == "H2"){
      const lis = index.getElementsByTagName("li");
      const h2li = lis[lis.length - 1];
      const h3ol = document.createElement('ol');
      h3li.appendChild(atag);
      h3ol.appendChild(h3li);
      h2li.appendChild(h3ol);
      index.appendChild(h2li);
    } else {
      const ols = index.getElementsByTagName("ol");
      const h3ol = ols[ols.length - 1];
      h3li.appendChild(atag);
      h3ol.appendChild(h3li);
    }
  }
}
document.getElementById("article-index").appendChild(index);

const hsSp = document.getElementsByClassName("sp")[0].querySelectorAll('h2, h3');
const indexSp = document.createElement('ol');
for(let i = 0; i < hsSp.length; i++){
  const tag = hsSp[i].tagName;
  if(tag == "H2"){
    const h2li = document.createElement('li');
    const atag = document.createElement('a');
    atag.href = `#${i}-sp`;
    hsSp[i].id = `${i}-sp`;
    atag.innerText = hsSp[i].innerText;
    
    h2li.appendChild(atag);
    indexSp.appendChild(h2li);
  } else {
    const h3li = document.createElement('li');
    const atag = document.createElement('a');
    atag.href = `#${i}-sp`;
    hsSp[i].id = `${i}-sp`;
    atag.innerText = hsSp[i].innerText;
    
    if(hsSp[i-1].tagName == "H2"){
      const lis = indexSp.getElementsByTagName("li");
      const h2li = lis[lis.length - 1];
      const h3ol = document.createElement('ol');
      h3li.appendChild(atag);
      h3ol.appendChild(h3li);
      h2li.appendChild(h3ol);
      indexSp.appendChild(h2li);
    } else {
      const ols = indexSp.getElementsByTagName("ol");
      const h3ol = ols[ols.length - 1];
      h3li.appendChild(atag);
      h3ol.appendChild(h3li);
    }
  }
}
document.getElementById("article-index-sp").appendChild(indexSp);